export interface CommandTextModelCapabilities {
  supportsReasoning?: boolean;
  reasoningAlwaysOn?: boolean;
  supportsWebSearch?: boolean;
}

const uiSystemToApiCompany: Record<string, string> = {
  OpenAI: 'openAi',
  anthropicAi: 'anthropic',
  Gemini: 'gemini',
  XAi: 'xai',
  Groq: 'groq',
};

export function findCommandTextModelCapabilities(
  systems: Array<{ system: string; models: Array<Record<string, unknown>> }>,
  aiSystemUi: string,
  modelName: string,
): CommandTextModelCapabilities | null {
  const apiCompany = uiSystemToApiCompany[aiSystemUi];
  if (!apiCompany || !modelName) {
    return null;
  }
  const system = systems.find(s => s.system === apiCompany);
  if (!system) {
    return null;
  }
  const model = system.models.find(m => m.model === modelName);
  if (!model) {
    return null;
  }
  return {
    supportsReasoning: model.supportsReasoning === true,
    reasoningAlwaysOn: model.reasoningAlwaysOn === true,
    supportsWebSearch: model.supportsWebSearch === true,
  };
}

export function getCommandTextReasoningVisible(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.supportsReasoning === true;
}

export function getCommandTextReasoningLockedOn(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.reasoningAlwaysOn === true;
}

export function getCommandTextWebSearchVisible(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.supportsWebSearch === true;
}
